import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findAutomatticTemplates = createAsyncThunk(
    "userTemplate/findAutomatticTemplates",
    async (template: string, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`${api.baseURL}formquestion`, {
                params: {
                    where: {
                        form: template,
                        template: { "!=": null },
                    },
                },
            })
            return data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);


        


